import { useSelector } from 'react-redux';
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';
import React from 'react';
import routes from '../routes';
import { getIsAuthenticated } from '../store/modules/auth/reducer';
import { LocationDescriptor } from 'history';

const removeAPIPageUri = (pathname: string): string => pathname.split('/p/')[0];

const PrivateRoute = (props: RouteProps) => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const location = useLocation();
  if (!isAuthenticated) {
    const referrer: LocationDescriptor = {
      pathname: removeAPIPageUri(location.pathname),
      state: location.state,
      hash: location.hash,
      key: location.key,
      search: location.search
    };
    return (
      <Redirect
        to={{
          ...routes.Login,
          search: location.search,
          state: {
            referrer
          }
        }}
      />
    );
  }
  return <Route {...props} />;
};

export default PrivateRoute;
